import axios from 'axios';
import Config from '@/Config';

const host = Config.host + "Companys/"


function getMyCompanys(){
  return axios.get(`${host}myCompanys`)
     .then(data => {
        return data.data
    })
}

/**
 * Crea una empresa. Recibe un objeto y no argumentos sueltos: eran seis
 * posicionales y con los campos nuevos (WhatsApp, reservas) habrian sido
 * nueve, donde equivocarse de orden no da ningun error, solo guarda mal.
 */
function saveCompany(datos){
  return axios.post(`${host}save`, {
    "idCompany": null,
    "idUser": null,
    "company": datos.company,
    "country": datos.country,
    "city": datos.city,
    "description": datos.description,
    "location": datos.location,
    "phone": datos.phone,
    "receivesWhatsapp": datos.receivesWhatsapp ?? false,
    "whatsapp": datos.whatsapp ?? null,
    "acceptsReservations": datos.acceptsReservations ?? false,
    "views": null
  }).then(data => {
    return data.data
  })
}
function updateCompany(companyData) {
  return axios.post(`${host}save`, companyData)
    .then(data => {return data.data} )
}

function getCompany(id){
  return axios.get(`${host}${id}`)
     .then(data => {
        return data.data
    })
}
function deleteImage(idImage){
  return axios.delete(`${host}DeleteImage/${idImage}`)
    .then(data => {
      return data.data
    })
}

function imageSave(imageBase64, idCompany){
  return axios.post(`${host}ImageSave`, {
    idEntity: idCompany,
    path: imageBase64
  }).then(data => {
        return data.data
    })
}
function ImagesCompany(idCompany) {
  return axios.get(`${host}ImagesCompany/${idCompany}`)
     .then(data => {
        return data.data
    })
}

function isEnabled(idCompany) {
  return axios.get(`${host}companyIsEnabled/${idCompany}`)
     .then(data => {
        return data.data
    })
}

function search(text, contry, city, page) {
  return axios.post(`${host}Search`, {
    text: text,
    contry: contry,
    city: city,
    page
  }).then(data => {
        return data.data
    })
}
function addCompanyView(idCompany) {
  return axios.post(`${host}${idCompany}/view`)
    .then(data => data.data)
}

function searchAll(text, page = 0, contry = "", city = "") {
  return axios.post(`${host}AllCompanies`, {
    text: text,
    page: page,
    contry: contry,
    city: city
  }).then(response => {
    return response.data;
  });
}

export default {
  getMyCompanys,
  saveCompany,
  updateCompany,
  getCompany,
  imageSave,
  ImagesCompany,
  deleteImage,
  isEnabled,
  search,
  addCompanyView,
  searchAll
}
